import { GridCard } from '../GridCard'
import { CarGridDetails } from './CarGridDetails'
import { GridCardPlaceholder } from '../GridCardPlaceholder'

export const CarGrid = ({
  cars,
  currency,
  openGarageModal,
  displayAddToGarageButton = false,
  loading,
}) => {
  if (!cars && !loading) return null

  if (loading) {
    return (
      <div className="mt-3 row">
        {Array.from({ length: 40 }).map(() => (
          <GridCardPlaceholder />
        ))}
      </div>
    )
  }

  return (
    <ul className="list-unstyled row mt-3">
      {cars.map((car) => (
        <li
          className="col-md-6 col-lg-3 col-6 my-3 align-item-stretch"
          key={car.id}
        >
          <GridCard
            key={`car-${car.id}`}
            openInNewTab={!App.State.isMobile}
            url={car.car_path}
            image={{
              src:
                App.State.supportsWebp && car.webp_image !== null
                  ? car.webp_image
                  : car.image,
              alt: car.title,
            }}
            description={car.details}
            country={car.location_country}
            withSoldMark={car.status === 'sold'}
            isPremium={!!car.premium_expires_at}
          >
            <CarGridDetails
              car={car}
              currency={currency}
              displayAddToGarageButton={displayAddToGarageButton}
              openGarageModal={openGarageModal}
            />
          </GridCard>
        </li>
      ))}
    </ul>
  )
}
